import { faBoxOpen } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'

const MyNoneItems = ({ title, subtitle }) => {
  return (
    <div className="flex h-full w-full flex-col items-center justify-center p-8 text-center">
      <FontAwesomeIcon
        aria-hidden="true"
        className="h-16 w-16 text-gray-500"
        icon={faBoxOpen}
      />
      <h3 className="text-sm font-medium text-gray-500">
        {title ? title : ' No hay productos que mostrar'}
      </h3>
      <p className="text-sm text-gray-500">
        {subtitle ? subtitle : 'Introduzca un criterio de búsqueda'}
      </p>
    </div>
  )
}

export default MyNoneItems

MyNoneItems.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
}
